import { IntegrationEventConstructor, IntegrationRequestConstructor } from "./IntegrationBus";
import { IntegrationEvent } from "./IntegrationEvent";
import { IntegrationRequest } from "./IntegrationRequest";

/** Factory class to create IntegrationEvent and IntegrationRequest classes with unique keys. */
class IntegrationBusFactory {
    /**
     * Creates a new IntegrationEvent class with a unique eventKey.
     * @param className The base name for the event class.
     * @returns A constructor for the new IntegrationEvent class.
     */
    public static createEvent<TPayload = void>(className: string): IntegrationEventConstructor<IntegrationEvent<TPayload>> {
        const randomSuffix = this.getRandomSuffix();

        return class extends IntegrationEvent<TPayload> {
            public static override readonly eventKey = `${className}_${randomSuffix}`;
        };
    }

    /**
     * Creates a new IntegrationRequest class with a unique requestKey.
     * @param className The base name for the request class.
     * @returns A constructor for the new IntegrationRequest class.
     */
    public static createRequest<TPayload = void, TResponse = void>(className: string): IntegrationRequestConstructor<IntegrationRequest<TPayload, TResponse>> {
        const randomSuffix = this.getRandomSuffix();

        return class extends IntegrationRequest<TPayload, TResponse> {
            public static override readonly requestKey = `${className}_${randomSuffix}`;
        };
    }

    /**
     * Generates a random suffix string.
     * @returns A random string to ensure uniqueness.
     */
    private static getRandomSuffix(): string {
        return Math.random().toString(36).substring(2, 8);
    }
}

export { IntegrationBusFactory };
